import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

const resizeEvents$ = new Subject();
function handleResize(e){
	resizeEvents$.next(e);
}
window.addEventListener('resize',handleResize);
window.addEventListener('orientation',handleResize);

const ViewportSizeChange = resizeEvents$.pipe(map(event=>{
    const data = {
        originalEvent: event,
        breakpoint: window.breakpoint,
        viewport: {
            width: document.documentElement.clientWidth,
            height: document.documentElement.clientHeight
        }
    }
    return data;
}))


export { ViewportSizeChange };